import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Wrapper as Icon } from 'components/shared/Icon/styles'

export const MultiSelectDropdown = styled(Box)`
    cursor: pointer;
    user-select: none;

    &:focus-visible {
        ${Text}, ${Icon} {
            color: ${({ theme }) => theme.colors.primary_500} !important;
        }
    }
`

interface ContentProps {
    isOpened: boolean
}
export const MultiSelectContent = styled(Box)<ContentProps>`
    overflow: hidden;
    max-height: ${({ isOpened }) => (isOpened ? '1000px' : 0)};
    transition: max-height 0.5s;
`
